
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 8.5a1.889 1.889 0 113.778 0A1.889 1.889 0 010 8.5zM6.611 8.5a1.889 1.889 0 113.778 0 1.889 1.889 0 01-3.778 0zM0 1.889a1.889 1.889 0 113.778 0 1.889 1.889 0 01-3.778 0zM6.611 1.889a1.889 1.889 0 113.778 0 1.889 1.889 0 01-3.778 0zM0 15.111a1.889 1.889 0 113.778 0 1.889 1.889 0 01-3.778 0zM6.611 15.111a1.889 1.889 0 113.778 0 1.889 1.889 0 01-3.778 0z"}})])
          )
        }
      }
    